/* Version: 3.5.155 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { useReducer } from 'react';
import handle from '../../utils/handle.js';
import useDerivedFlag from '../../hooks/useDerivedFlag.js';

var DEFAULT_STATE = {
  isExpanded: false
};
var ACCORDION_ACTIONS = {
  CLICK_PANEL: 'clickPanel'
};
var CLICK_PANEL = ACCORDION_ACTIONS.CLICK_PANEL;
function accordionReducer(state, _ref) {
  var type = _ref.type;
  switch (type) {
    case CLICK_PANEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isExpanded: !state.isExpanded
      });
    // istanbul ignore next
    default:
      return state;
  }
}
function useAccordion(_ref2) {
  var controlledExpanded = _ref2.controlledExpanded,
    defaultExpanded = _ref2.defaultExpanded,
    onToggle = _ref2.onToggle;
  var _useReducer = useReducer(accordionReducer, DEFAULT_STATE, function (defaultState) {
      return _objectSpread(_objectSpread({}, defaultState), {}, {
        isExpanded: defaultExpanded
      });
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    stateExpanded = _useReducer2[0].isExpanded,
    dispatch = _useReducer2[1];
  var isDerived = useDerivedFlag(controlledExpanded);
  var handleToggle = handle(onToggle);
  if (isDerived) {
    return {
      isExpanded: controlledExpanded,
      onClickHeader: function onClickHeader(event) {
        handleToggle(event, controlledExpanded);
      }
    };
  }
  return {
    isExpanded: stateExpanded,
    onClickHeader: function onClickHeader(event) {
      handleToggle(event, stateExpanded);
      dispatch({
        type: CLICK_PANEL
      });
    }
  };
}

export { useAccordion as default };
